<ng-container *transloco="let t">
  @let isDepartmentsStateLoaded = isDepartmentsStateLoaded$ | async;
  @let departments = departments$ | async;
  @if (!patient) {
    <tui-block-status>
      <pxc-lottie-label animation="patientEmpty" [message]="t('Cet identifiant patient n\'existe pas')" />
      <button class="mt-8" tuiButton type="button" (click)="cancel()">
        {{ t('Revenir à la liste des patients') }}
      </button>
    </tui-block-status>
  } @else {
    <div class="mb-6 flex items-center gap-5" data-testid="patient-data">
      <pxc-patient-avatar [patient]="patient" [size]="Size.LARGE" />
      <pxc-patient-data data-testid="patient-details" [patient]="patient" [size]="Size.LARGE" />
    </div>

    @if (!isDepartmentsStateLoaded) {
      <button
        class="mt-4 flex h-12 w-full rounded-lg shadow-xs"
        type="button"
        [tuiSkeleton]="!isDepartmentsStateLoaded"></button>
    } @else {
      @if (departments.length > 0) {
        <p>{{ t('Vous faites partie de plusieurs groupes comportant ce patient.') }}</p>
        <p>{{ t('Dans quel contexte souhaitez-vous consulter ce dossier patient ?') }}</p>
        <div class="mt-8 flex flex-col justify-center gap-4">
          @for (department of departments; track department.id) {
            @let departmentAvatarStyle = getDepartmentAvatarStyle(department);
            <button
              class="flex w-full flex-row items-center justify-between rounded-lg bg-background-primary p-4 shadow-xs"
              type="button"
              (click)="pickDepartment(department.id)">
              <div
                class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg text-sm uppercase"
                [ngStyle]="{
                  backgroundColor: departmentAvatarStyle.backgroundColor,
                  color: departmentAvatarStyle.textColor,
                }">
                {{ department?.name.charAt(0) || '?' }}
              </div>
              <div class="ml-3 min-w-0 flex-1 overflow-hidden">
                <h2 class="truncate text-left">{{ department.name }}</h2>
                <p class="truncate text-left text-sm text-text-quaternary">
                  {{ t('Consulter ce dossier patient dans le groupe {{name}}', { name: department.name }) }}
                </p>
              </div>
              <div class="ml-3 flex h-6 w-6 shrink-0 items-center justify-center">
                <tui-icon class="text-foreground-quaternary" icon="@tui.chevron-right" />
              </div>
            </button>
          }
        </div>
      }
      <button
        class="mt-4 flex w-full flex-row items-center justify-between rounded-lg bg-background-primary p-4 shadow-xs"
        type="button"
        (click)="pickDepartment(-1)">
        <tui-icon
          class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg text-sm uppercase text-foreground-primary"
          icon="@tui.user" />
        <div class="ml-3 min-w-0 flex-1 text-start">
          <h2>{{ t('Mes patients') }}</h2>
          <p class="line-clamp-2 text-sm text-text-quaternary">
            {{ t('Consulter toutes les données auxquelles vous avez accès pour ce patient') }}
          </p>
        </div>
        <div class="ml-3 flex h-6 w-6 shrink-0 items-center justify-center">
          <tui-icon class="text-foreground-quaternary" icon="@tui.chevron-right" />
        </div>
      </button>
    }

    <button appearance="outline" class="mt-8" tuiButton type="button" (click)="cancel()">
      {{ t('Annuler') }}
    </button>
  }
</ng-container>
